module.exports = __webpack_public_path__ + "assets/img/third_left_arrow.eb70db56.png";